import { render, staticRenderFns } from "./IconWorld.vue?vue&type=template&id=df1a67e2&"
import script from "./IconWorld.vue?vue&type=script&lang=ts&"
export * from "./IconWorld.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports